import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { initAmplifyAuth } from '@cp/core/auth';
import { getRouter } from '@cp/core/routing';
import { ENABLE_API_MOCK } from '@/constants/env.constants';
import { initSentry } from '@/sentry';

import { App } from './app';

// TODO: maybe move react-toastify to design system
import './index.css';

const initApp = async () => {
  if (ENABLE_API_MOCK !== 'true') {
    return true;
  }

  const { enableApiMocking } = await import('@mocks/api.mock');
  const mockService = await enableApiMocking();

  return mockService?.active?.state === 'activated';
};

initApp()
  .then(async () => {
    await initAmplifyAuth();
    initSentry();

    const rootNode = document.getElementById('root');
    const router = await getRouter();

    if (rootNode) {
      ReactDOM.createRoot(rootNode).render(
        <StrictMode>
          <App router={router} />
        </StrictMode>,
      );
    }
  })
  .catch(console.error);
